import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText, FDDisplayText, FDHeadlineText, FDTitleText,
} from '@facet-wealth/design';
import AdditionalDetailsSubSections from './Layout/AdditionalDetailsSubSections/AdditionalDetailsSubSections';
import AdditionalDetailsSections from './Layout/AdditionalDetailsSections/AdditionalDetailsSections';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDisplayText,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDTitleText,
  }, overrideReadOnly)
  .nameOverride('sectionTitle', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('sectionSubtitle', {
    _component: () => FDBodyText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('subSectionTitle', {
    _component: () => FDHeadlineText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('sections', {
    _component: () => AdditionalDetailsSections,
  }, overrideReadOnly)
  .nameOverride('subSections', {
    _component: () => AdditionalDetailsSubSections,
  }, overrideReadOnly);

export default metaOverrideSet;
